import { PublicPageWrapper } from 'App/presentation/components';
import { MODULE_PATH } from 'Heartbeat/routes/routes';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const AppFallbackUI = () => {
  return (
    <PublicPageWrapper>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          pt: 4,
        }}
      >
        <Paper sx={{ p: 4 }}>
          <Typography sx={{ mb: 2 }} variant="h4">
            <FormattedMessage
              id="ErrorBoundary-AppFallbackUI-title"
              defaultMessage="We're sorry - something's gone wrong."
            />
          </Typography>
          <Typography sx={{ mb: 2 }} variant="subtitle1">
            <FormattedMessage
              id="ErrorBoundary-AppFallbackUI-content"
              defaultMessage="If the error continues to occur please contact us for help."
            />
          </Typography>
          <Box
            component="a"
            sx={{
              color: 'primary.main',
            }}
            href={`/${MODULE_PATH}`}
          >
            <FormattedMessage id="ErrorBoundary-AppFallbackUI-button" defaultMessage="Try going back to Console" />
          </Box>
        </Paper>
      </Box>
    </PublicPageWrapper>
  );
};

export default AppFallbackUI;
